import * as React from "react"
import Layout from "../components/layout";
import SectionCard from "../components/SectionCard";

// markup
const IndexPage = () => {
  return (
    <Layout title={"Laura & Johannes"}>
      <section className="text-right p-8 pt-5 sm:pt-8 md:pt-8 mt-20">
        <h1 className="font-pretty text-primary text-4xl xs:text-5xl sm:text-6xl pretty md:text-7xl lg:text-8xl md:leading-20 lg:leading-30 normal-case tracking-normal text-left xs:text-left">
          Laura &<br/>
          <span className="relative left-4 xs:left-20 sm:left-32 lg:left-44 top-6">Johannes</span>
        </h1>
        <div className="mt-24 xs:mt-20 md:mt-32 lg:mt-28">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl tracking-wide md:tracking-widest lg:tracking-wider uppercase mb-10 lg:mb-12">
            Wir heiraten <span className="">&</span><br/>
            möchten mit euch feiern!
          </h2>
          <h3 className="mt-8 text-xl md:text-2xl tracking-wide xs:tracking-widest uppercase">
            Trauung | 14. Mai 2022 | 14 Uhr<br/>
            St. Georg Kirche
          </h3>
          <p className="mt-1 text-xl md:text-xl tracking-wider">
            Niederbüssauer Weg 1, 23560 Lübeck Genin
          </p>
          <h3 className="mt-8 text-xl md:text-2xl tracking-wide xs:tracking-widest uppercase">
            Empfang & Feier | 14. Mai 2022 | 15 Uhr<br/>
            Gut Mönkhof
          </h3>
          <p className="mt-1 text-xl md:text-xl tracking-wider">
            Mönkhofer Weg 265, 23562 Lübeck
          </p>
          <h3 className="mt-8 text-xl md:text-2xl tracking-wide xs:tracking-widest uppercase">
            Brunch | 15. Mai 2022 | ab 10 Uhr<br/>
            Gut Mönkhof
          </h3>
          <p className="mt-1 text-xl md:text-xl tracking-wider">
            Mönkhofer Weg 265, 23562 Lübeck
          </p>
        </div>
      </section>
      <SectionCard href="/rsvp">
        <h2 className="font-medium">RSVP</h2>
        <p className="">
          Hier geht es zur Rückmeldung.<br/>
          Wir freuen uns auf eure Zusage bis zum 15.01.
        </p>
        <div className={"font-medium rounded text-white bg-primary p-2 max-w-60"}>Jetzt Rückmeldung geben!</div>
      </SectionCard>
      <SectionCard href="/hotels">
        <h2 className="font-medium">Hotels</h2>
        <p>Wenn ihr in der Nähe schlafen wollt, findet ihr hier Hotelvorschläge.</p>
      </SectionCard>
      <SectionCard href="/geschenke">
        <h2 className="font-medium">Geschenkideen</h2>
        <p>Euer Kommen ist das größte Geschenk – Wenn ihr uns trotzdem etwas schenken wollt, findet ihr hier Ideen.</p>
      </SectionCard>
      <SectionCard href="/kontakt">
        <h2 className="font-medium">Weitere Infos</h2>
      </SectionCard>
      <SectionCard href="/fotos">
        <h2 className="font-medium">Fotos</h2>
      </SectionCard>
    </Layout>
  )
}

export default IndexPage
